export default "__VITE_ASSET__297b3d60__"